/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Brevalt API
 * Customer API of Brevalt (CRA vulnerability reporting). Errors are RFC 9457 problem+json.
 * OpenAPI spec version: 0.29.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Dashboard,
  Problem
} from '../model';

import { customerFetch } from '../../../http.ts';
import type { ErrorType } from '../../../http.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetDashboardUrl = () => {




  return `/api/v1/dashboard`
}

/**
 * @summary Needs you now (open cases by nearest deadline, findings to assess and to triage, failed scans) and a status ring per product, in the caller's product scope; open cases need case.read
 */
export const getDashboard = async ( options?: Parameters<typeof customerFetch>[1]): Promise<Dashboard> => {

  return customerFetch<Dashboard>(getGetDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardQueryKey = () => {
    return [
    `/api/v1/dashboard`
    ] as const;
    }


export const getGetDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<Problem>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboard>>> = ({ signal }) => getDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboard>>>
export type GetDashboardQueryError = ErrorType<Problem>


export function useGetDashboard<TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<Problem>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboard>>,
          TError,
          Awaited<ReturnType<typeof getDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboard<TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<Problem>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboard>>,
          TError,
          Awaited<ReturnType<typeof getDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboard<TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<Problem>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Needs you now (open cases by nearest deadline, findings to assess and to triage, failed scans) and a status ring per product, in the caller's product scope; open cases need case.read
 */

export function useGetDashboard<TData = Awaited<ReturnType<typeof getDashboard>>, TError = ErrorType<Problem>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






